import React from 'react';
import { observer } from 'mobx-react';
import { MissingDocumentListTemplate } from 'themes/application/missing-document/pages';
import { setCurrentView } from 'core/utils';
import { MissingDocumentViewStore } from 'application/missing-document/stores';

@setCurrentView((rootStore) => new MissingDocumentViewStore(rootStore), 'listViewStore')
@observer
class MissingDocumentList extends React.Component {
    render() {
        return <MissingDocumentListTemplate {...this.props} />
    }
}

export default MissingDocumentList;